import axios from 'axios';

export default function getVars() {
    // Retrieve the environment variables
    return axios.get('api/getEnvironmentVariables/')
        .then(response => response.data).catch((error) => {
            console.error(error);
            return {};
        });
}
